import { useMemo } from 'react';
import { AllBrandsStatsResponse } from '../../../../shared/models/projects/stats/AllBrandsStatsResponse';
import { generateVisibilitySummary } from '../helpers/ProjectPreviewHelper';
import { getTextForVisibility } from '../../../../shared/utils/utils';
import { PromptsData } from '../../../prompt/models/PromptsData';
import { ChatType } from '../../../../shared/types/monitor/ChatType';
import { AccountResponse } from '../../../../shared/models/account/AccountResponse';
import { TagsResponse } from '../../../../shared/models/tags/TagsResponse';
import { KeywordResponse } from '../../../../shared/models/monitor/KeywordResponse';

export const useVisibilityTexts = (
  firmName: string,
  firmNameLabel: string,
  currentBrandGeneralStats: AllBrandsStatsResponse | null,
  promptsData: PromptsData[] | null,
  chatType: ChatType | null,
  accountResponse: AccountResponse | null,
  allModelsMatrix: string[][] | null,
  tags: TagsResponse[],
  commonKeywords: KeywordResponse[]
) => {
  return useMemo(() => {
    if (!currentBrandGeneralStats || !promptsData || !chatType || !accountResponse) {
      return [];
    }

    return generateVisibilitySummary(
      firmName,
      firmNameLabel,
      getTextForVisibility(currentBrandGeneralStats.brandScore),
      promptsData,
      chatType,
      allModelsMatrix,
      tags,
      commonKeywords
    );
  }, [
    firmName,
    firmNameLabel,
    currentBrandGeneralStats,
    promptsData,
    chatType,
    accountResponse,
    allModelsMatrix,
    tags,
    commonKeywords,
  ]);
};
